import { supabase } from './supabase';

/**
 * Send a magic link to the owner's email.
 * Supabase's built-in auth handles the email; SMTP is configured as Resend
 * in the Supabase Dashboard > Authentication > SMTP Settings.
 */
export async function requestMagicLink(email: string): Promise<void> {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: {
      emailRedirectTo: `${window.location.origin}/auth/callback`,
    },
  });
  if (error) throw error;
}

/**
 * Exchange a viewer token (from a shared link) for a read-only session.
 * Calls the verify-viewer-link Netlify function, which validates the token
 * and returns a short-lived Supabase JWT with a `viewer_for` claim.
 */
export async function exchangeViewerToken(token: string): Promise<{
  access_token: string;
  expires_at: number;
  owner_id: string;
}> {
  const res = await fetch('/api/verify-viewer-link', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: 'unknown' }));
    throw new Error(body.error || `Viewer token rejected (${res.status})`);
  }
  return res.json();
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut();
  // Clear any viewer token stashed in sessionStorage
  sessionStorage.removeItem('viewer_session');
  window.location.href = '/';
}
